import moment from "moment";
import axios from "@util/axios";
import store from "@store";

class DownloadsService {
	constructor() {
		this.downloads = store.getters.downloads;

		store.subscribe((mutation, state) => {
			this.downloads = {
				count: state.downloads.downloads.count,
				results: state.downloads.downloads.results.map(
					(item, item_i) => {
						let name = !item.folder_path
							? item.files[0].name
							: item.files.length
							? item.files[item.files.length - 1].name
							: item.folder_path;

						let date = name ? name.split("_")[0].split("-") : false;

						let link = !item.folder_path
							? item.files[0].link
							: item.files.length
							? item.files[item.files.length - 1].link
							: null;

						let files = !item.folder_path ? [] : item.files;
						files.pop();

						let parameters = item.parameters;

						if (Array.isArray(parameters)) {
							let newParameters = {};

							parameters.forEach((pitem) => {
								if (newParameters[pitem.name])
									newParameters[pitem.name].concat(
										item.value
									);
								else newParameters[pitem.name] = pitem.value;
							});

							parameters = newParameters;
						}

						return {
							id: item_i,
							downloadId: item.id,
							date: date
								? moment(
										`${date[2]}-${date[0]}-${date[1]}`
								  ).format("MMM D, YYYY")
								: "",
							name: name,
							link: link,
							files: files,
							parameters: parameters,
							is_pending: item.is_pending,
							is_failed: item.is_failed,
							note: item.note,
						};
					}
				),
			};
		});
	}

	set(type = "downloads", data) {
		if ("list" === type)
			store.commit(
				"GET_DOWNLOADS",
				data
					? {
							count: data.length,
							results: data,
					  }
					: null
			);
	}

	async list(params, commit = true) {
		const rs = await axios({
			url: `/downloaded_reports/`,
			params: params || null,
		});

		if (commit) store.commit("GET_DOWNLOADS", rs.data.data);

		return rs;
	}
}

export default new DownloadsService();
